import React, {Component} from 'react';
import './Admin.css';
import TeamTable from './TeamTable'

import { useQuery } from '@apollo/client';
import { FIND_TEAM_UNI } from '../../queries';

const AdminUniPage = () => {
    const { error, data } = useQuery(FIND_TEAM_UNI);

    if (error) return `Error! ${error.message}`;

    return (
        <TeamTable teams={data?.findTeamUniv}/ >
    );
}

export default AdminUniPage
